import { createFileRoute, Navigate } from '@tanstack/react-router';

import { OpenShiftResponsesSection } from '@apps/web/components/settings/open_shift_responses_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/open-shift-responses')({
    component: OpenShiftResponsesPage,
});

function OpenShiftResponsesPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Open shift responses"
            description="Configure how Phoebe handles responses to open shift offers."
        >
            <OpenShiftResponsesSection organizationId={organizationId} />
        </SettingsPageShell>
    );
}
